var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoExport24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_import24x24",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "import",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25292",
    "data-name": "Group 25292",
    transform: "rotate(180 4.566 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25291",
    "data-name": "Group 25291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46241",
    "data-name": "Path 46241",
    d: "M9.008,219.917a.5.5,0,0,0-.4-.145l-3.889.353a.5.5,0,0,0-.309.852l1.061,1.061-5.3,5.3a.5.5,0,0,0,0,.707l.707.707a.5.5,0,0,0,.707,0l5.3-5.3,1.061,1.061a.5.5,0,0,0,.524.117.508.508,0,0,0,.183-.117A.494.494,0,0,0,8.8,224.2l.354-3.889a.5.5,0,0,0-.146-.394Z",
    transform: "translate(-.024 -219.77)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25294",
    "data-name": "Group 25294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25293",
    "data-name": "Group 25293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46242",
    "data-name": "Path 46242",
    d: "M15,0H1A1,1,0,0,0,0,1V9H2V2H14V14H7v2h8a1,1,0,0,0,1-1V1A1,1,0,0,0,15,0Z",
    fill: "#999"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoExport24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_export24x24.bc7f9a1670253e788df2c77701858247.svg";